import './DashboardCard.css';
import DRResourceIcon from '../../../assets/icons/dr_resource.svg?react';
import { useMemo } from 'react';

const DRResourceCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { drResourceData } = dashboardData;
  
  // DR 자원이 선택되었는지 확인 (선택된 DR 자원이 있으면 1, 없으면 0)
  const drResourceCount = useMemo(() => {
    if (!drResourceData?.Items || drResourceData.Items.length === 0) {
      return 0;
    }
    return 1;
  }, [drResourceData]);
  
  return (
    <div 
      className="dashboard-card flex flex-col justify-between" 
    >
      <div className="icon-container icon-blue">
        <DRResourceIcon/>
      </div>
      <div className="dashboard-card-content flex flex-col gap-10">
        <h3 className="text-b1-700 text-gray-600">포함된 DR 자원</h3>
        <p className="text-h1 text-gray-700">{drResourceCount}</p>
      </div>
    </div>
  );
};

export default DRResourceCard;
